export default __webpack_public_path__ + "static/media/fragua.406e81a3.png";